import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/effect-fade';
if (customElements.get('component-carousel') === undefined) {
    class Carousel extends HTMLElement {
        constructor() {
            super();
            this.images = this.querySelectorAll('img');
            this.swiper = this.querySelector('.swiper');
            this.dinamic_height = this.getAttribute('dinamic-height');
            this.carousel = null;
            this.interval = parseInt(this.swiper.getAttribute('data-interval'));
            if (this.dinamic_height) {
                //this.setDinaicHeight()
                //window.addEventListener('resize', this.setDinaicHeight.bind(this))
            }
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
        }
        setDinaicHeight() {
            const wiewportHeight = window.innerHeight;
            const headerHeight = document.querySelector('header').offsetHeight;
            const sectionNavigation = document.querySelector('header');
            const navigationHeight = sectionNavigation.offsetHeight;
            this.style.height = `${wiewportHeight - headerHeight - navigationHeight}px`;
        }
        setCarousel() {
            this.carousel = new Swiper(this.swiper, {
                modules: [Navigation, Pagination, EffectFade, Autoplay],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 700,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                autoplay: {
                    delay: this.interval
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }
    }
    customElements.define('component-carousel', Carousel);
}
